import type * as expressionNode from '../../node'
import { getHelper } from '../all'
import { Fn } from '../fn'

/**
 * __NOTE:__ this will not always return a {@link data.expression.fn.node.Node} because sometimes
 * {@link Fn} expressions can be converted to {@link expression.node.ForValue}
 */
export function from<T>(
  fn: Fn<T>,
  context: expressionNode.Context,
): expressionNode.Node<T> {
  const fnUsingKey = Fn.UsingKey.from(fn)
  return getHelper(fnUsingKey).createNode(fnUsingKey, context)
}
